import aReader from '@/libs/chunkReader.js';
import { saveAs } from 'file-saver';

const chunkSize = 5000000; // 50MB

export class DecryptFile {
  constructor({ url, size, fileName, finish, privateKey, passPhrase, progress }) {
    this.url = url;
    this.size = size;
    this.chunkSize = Math.min(size, chunkSize);
    this.reader = new aReader.ChunkReader(url, size, chunkSize);
    this.decryptedChunks = new Uint8Array();
    this.decryptedLength = 0;
    this.chunksLength = 0;
    this.blob = null;
    this.finish = finish;
    this.fileName = fileName;
    this.privateKey = privateKey;
    this.passPhrase = passPhrase;
    this.progress = progress;
    this.worker = new Worker('/libs/openpgp/workers/decrypt.js');
    this.checkedKey = false;
    this.read();
  }
  read() {
    return this.reader.read(async (data) => {
      if (!this.checkedKey) {
        try {
          await this.checkKey();
          this.checkedKey = true;
        } catch (error) {
          this.clearWorker();
          this.finish({ error: error?.message });
          return;
        }
      }

      if (!data) {
        await this.decrypt();
        return;
      }
      this.writeChunkToStream(data);
      this.chunksLength += data.length;
      if (this.chunksLength !== this.size) {
        this.progress({ received: this.chunksLength, total: this.size });
      }
      this.read();
    });
  }
  async decrypt() {
    try {
      this.decrypted = await this.workerHandler({ cmd: 'decryptMessage' });
      this.progress({ received: 1, total: 1 });
      saveAs(this.decrypted, this.fileName);
      this.finish({ file: this.decrypted });
      this.clearWorker();
    } catch (error) {
      this.finish({ error: error?.message });
    }
  }
  checkKey() {
    const { privateKey, passPhrase } = this;
    return this.workerHandler({ privateKey, passPhrase, cmd: 'checkKey' });
  }
  writeChunkToStream(chunk) {
    return this.workerHandler({ chunk, cmd: 'write' });
  }
  workerHandler(...args) {
    return new Promise((resolve, reject) => {
      this.worker.onmessage = async ({ data: { response, error } }) => {
        if (error) {
          reject(new Error(error));
        }
        resolve(response);
      };
      this.worker.postMessage(...args);
    });
  }
  cancel() {
    this.reader.stop();
    this.clearWorker();
  }
  clearWorker() {
    this.worker?.terminate?.();
    this.worker = null;
  }
}
